import mapProps from "./mapProps";
import omit from "./utils/omit";
export function omitProps() {
  var propNames = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    propNames[_i] = arguments[_i];
  }

  return mapProps(function (props) {
    return omit.apply(void 0, [props].concat(propNames));
  });
}
export default omitProps;